import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GameSessionState {
  sessionActive: boolean;
  sessionId: string | null;
  sessionTarget: number | null;
  team1SessionScore: number;
  team2SessionScore: number;
  sessionOver: boolean;
  sessionWinner: string | null;
}

const initialState: GameSessionState = {
  sessionActive: false,
  sessionId: null,
  sessionTarget: null,
  team1SessionScore: 0,
  team2SessionScore: 0,
  sessionOver: false,
  sessionWinner: null
};

const gameSessionSlice = createSlice({
  name: 'gameSession',
  initialState,
  reducers: {
    setSessionData: (state, action: PayloadAction<GameSessionState>) => {
      Object.assign(state, action.payload);
    },
    resetSession: () => initialState
  }
});

export const { setSessionData, resetSession } = gameSessionSlice.actions;
export default gameSessionSlice.reducer;
